import {
  CLEAN_DETAIL_ORDER_VINCULATION_LIST,
  CLEAN_DETAIL_ORDER_VINCULATION_LIST_ERROR,
  DETAIL_ORDER_VINCULATION_LIST,
  DETAIL_ORDER_VINCULATION_LIST_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  response: undefined,
  status: undefined,
  state: undefined,
};

export default function orderVinculationDetailListReducer(state = initialState, action) {
  switch (action.type) {
    case DETAIL_ORDER_VINCULATION_LIST:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        response: action?.response || {},
        status: action?.status || null,
        state: 'success',
      };

    case DETAIL_ORDER_VINCULATION_LIST_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        response: action?.response || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_DETAIL_ORDER_VINCULATION_LIST:
      return {
        ...state,
        loaded: false,
        method: undefined,
        response: action?.response || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_DETAIL_ORDER_VINCULATION_LIST_ERROR:
      return {
        ...state,
        loaded: false,
        method: undefined,
        response: action?.response || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
